module.exports = __webpack_public_path__ + "static/media/err-img.7f6c42c1.jpg";